// Sentry initialization for the web app. Imported FIRST in main.tsx so it wraps
// the whole runtime. DSN comes from VITE_SENTRY_DSN (publishable) — when absent
// (local dev without config) Sentry stays disabled instead of throwing.
import * as Sentry from '@sentry/react';

function detectEnvironment(): 'local' | 'development' | 'production' {
  if (typeof window === 'undefined' || import.meta.env.DEV) return 'local';
  const host = window.location.hostname;
  if (/^(127\.0\.0\.1|localhost|192\.168\.|10\.)/.test(host)) return 'local';
  if (host.endsWith('.pages.dev') || host.includes('dev')) return 'development';
  return 'production';
}

const dsn = import.meta.env.VITE_SENTRY_DSN;
const environment = detectEnvironment();

if (dsn) {
  Sentry.init({
    dsn,
    environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: environment === 'production' ? 0.2 : 0.05,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: environment === 'production' ? 1.0 : 0,
  });
}
